import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import { motion } from 'framer-motion';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { isLoggedIn } from '../../authUtils';
import { useSendOtpMutation, useSignUpAuthMutation, useVerifyOtpMutation } from '../../redux/APIs/authApi';
import { setUser } from '../../redux/Slices/userSlice';
import { logoUrl } from '../BrandLogo/Logo';
import DatePicker from '../layout/DatePicker/DatePicker';
import Loader from '../layout/Loader/Loader';
import './SigninSignupComponent.css';

const SignInSignupComponent = ({ slModalClose, showAlert, setLoggedIn }) => {
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState('');
  const phoneNumberInputRef = useRef(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpCodes, setOtpCodes] = useState(['', '', '', '']);
  const otpInputRefs = useRef([]);

  const [isLoading, setIsLoading] = useState(false);
const [genderErrorMessage, setGenderErrorMessage] = useState('');
  const [name, setName] = useState('');
  const [isNameValid, setIsNameValid] = useState(false);
  // const nameInputRef = useRef(null);
  const [dob, setDob] = useState('');
  const [selectedDob, setSelectedDob] = useState('');
  const dobInputRef = useRef(null);
  const [gender, setGender] = useState('');
  const genderInputRef = useRef(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isEmailInputFocused, setIsEmailInputFocused] = useState(false);
  const emailInputRef = useRef(null);
  const [password, setPassword] = useState('');
  const passwordInputRef = useRef(null);
  const [isPasswordInputFocused, setIsPasswordInputFocused] = useState(false);
  const [slideType, setSlideType] = useState('sendOtp');

  console.log('emailError', emailError)

  
  console.log(dob);
  console.log('otpCodes', otpCodes);

  const [sendOTP, {isLoading: sendingOTP}] = useSendOtpMutation();
  const [verifyOTP, {isLoading: verifyOTPLoading}] = useVerifyOtpMutation();
  const [signUp, {isLoading: signUpLoading}] = useSignUpAuthMutation()

  

  // const { loading } = useSelector((state) => state.otp);
  // const shouldProceedToSignup = true

  useEffect(() => {
    phoneNumberInputRef.current?.focus();
  }, [phoneNumber]);

  

  const isValidPhoneNumber = /^[6-9]\d{9}$/.test(phoneNumber);
  
  const handleSendOTP = async () => {
    try {
      // Phone number validation
      if (!isValidPhoneNumber) {
        setPhoneNumberError('Invalid phone number');
        return;
      }

      console.log('Clicked');

      // Attempt to send OTP
      const response = await sendOTP(phoneNumber);
      console.log('response', response);

      if (response?.data?.message === 'OTP sent successfully') {
        setSlideType('verifyOtp');
      }

    } catch (error) {
      console.error('Error sending OTP:', error);
      setPhoneNumberError('Failed to send OTP. Please try again.');
    }
  };

  

  const handlePhoneNumberChange = (e) => {
    const inputValue = e.target.value;
    const trimmedValue = inputValue.slice(0, 10); // Trim input to 10 characters
    setPhoneNumber(trimmedValue);
    if (trimmedValue.length === 10) {
      phoneNumberInputRef.current.blur();
    }
  };

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };


  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  const handleOtpCodeChange = async (index, value) => {
    const updatedOtpCodes = [...otpCodes];
    updatedOtpCodes[index] = value;
    setOtpCodes(updatedOtpCodes);
    const otpString = updatedOtpCodes.join('');
    console.log('otpString', otpString);

    const isComplete = updatedOtpCodes.every((code) => code !== '');
    if (isComplete) {
        try {
            const response = await verifyOTP({ phoneNumber, otp: otpString });
            console.log('response', response);
            if (response?.data?.message === 'User logged in successfully') {
              dispatch(setUser(response?.data?.user));
              setLoggedIn(isLoggedIn());
              slModalClose();
            }

            if (response?.data?.shouldProceedToSignup === true) {
                setSlideType('name');
            } else if (response?.data?.message === 'User logged in successfully') {
                slModalClose();
            }
        } catch (error) {
            console.error('Error verifying OTP:', error);
        }
    } else if (value.length === 1 && index < 3) {
        setTimeout(() => {
            otpInputRefs.current[index + 1].focus();
        }, 0);
    }
};


  const handleOtpKeyDown = (index, event) => {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      const updatedOtpCodes = [...otpCodes];
      updatedOtpCodes[index] = '';
      setOtpCodes(updatedOtpCodes);
      console.log(updatedOtpCodes.join(''));

      if (index > 0 && otpCodes[index] === '') {
        setTimeout(() => {
          otpInputRefs.current[index - 1].focus();
        }, 0);
      }
    }
  };
  // useEffect(() => {
  //   // Focus on the first OTP input field initially
  //   otpInputRefs.current[0].focus();
  // }, []);

  console.log(phoneNumber)
// console.log(shouldProceedToSignup);
  // useEffect(() => {
  //   if (shouldProceedToSignup) {
  //     // setIsLoading(true); // Show the loader
  //     setTimeout(() => {
  //       setSlideType('name')
  //     }, 8000); // Adjust the delay time according to your needs
  //   }
  // }, [shouldProceedToSignup]);
  
  
  // const handleVerifyOTP = (phoneNumber, otpString) => {
  //   setIsLoading(true); // Show the loader while verifying OTP
  
  //   // Handle OTP verification logic
  //   // Simulating backend response for demonstrationZ
  //   dispatch(verifyOTP(phoneNumber, otpString))
  //     .then((data) => {
  //       console.log(data);
  
  //       if (data.user) {
  //         // User is logged in successfully
  //         console.log('User Logged in Successfully!');
  //         slModalClose();
  //         showAlert('success', 'User Logged in Successfully!');
  //         // Close the signinSignupComponent popup or perform any other necessary actions
  //       } else if (data) {
  //         console.log(data); // Log response.data here
  //         setShowNameSlide(true);
  //         setShowVerifyOTPSlide(false);
  
  //         // Proceed to the next signup step
  //         // Show the next name slide or perform any other necessary actions
  //       }
  //     })
  //     .catch((error) => {
  //       setIsLoading(false); // Hide the loader
  
  //       // Handle any errors that occurred during OTP verification
  //       console.log('Error:', error);
  //       // Perform any error handling or display error messages as needed
  //     });
  // };

  

  const handleNameChange = (e) => {
    const newName = e.target.value;
    console.log("Current name input value:", newName);
    setName(newName);
    setIsNameValid(newName.length >= 5 && newName.length <= 20);
  };

  // const handleNameInputFocus = () => {
  //   if (name.length < 5 && !isNextButtonClicked) {
  //     nameInputRef.current.focus();
  //   }
  // };
  // const handleDobChange = (e) => {
  //   e.preventDefault();
  //   setDob(e.target.value);
  // };
  
  const handleDateSelection = (newDob) => {
    setSelectedDob(newDob);
  };

  console.log('dob', dob);
  const handleGenderSelect = (selectedGender) => {
    if (selectedGender) {
      // setIsLoading(true);
      setGender(selectedGender);
      if (gender) {
        setGenderErrorMessage('');
        setSlideType('dob')
  
        // Simulate a delay of 2 seconds before transitioning to the next slide
        // setTimeout(() => {
        //   setSlideType('dob')
        // }, 500);
      } else {
        setGenderErrorMessage('Please select one of the options.');
      }
    } else {
      setGenderErrorMessage('Please select one of the options.');
    }
  };

  const handleEmailInputFocus = () => {
    setIsEmailInputFocused(true);
  };
  const handleEmailInputBlur = () => {
    setIsEmailInputFocused(false);
  };
  const handlePasswordInputFocus = () => {
    setIsPasswordInputFocused(true);
  };
  const handlePasswordInputBlur = () => {
    setIsPasswordInputFocused(false);
  };

  const validateEmail = (email) => {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email);
  };
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    
    setEmail(newEmail);
    if (newEmail && !validateEmail(newEmail)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    setPassword(e.target.value);
  };
  console.log(otpCodes)
  const handleBackButton = () => {
    // if (showVerifyOTPSlide) {
    //   setShowSendOTPSlide(true);
    //   setShowVerifyOTPSlide(false);
    // } else 
    if (slideType === 'name') {
      setSlideType('verifyOtp');

    } else if (slideType === 'dob') {
      setSlideType('name');
    } else if (slideType === 'gender') {
      setSlideType('dob');
    } else if (slideType === 'email') {
      setSlideType('gender');
    } else if (slideType === 'password') {
      setSlideType('email');
    }
  };
  const handleNameSubmit = () => {
    if (isNameValid) {
      setIsLoading(true);
        setSlideType('dob')
    } else {
      console.log('Invalid name');
    }
  };

  const handleGenderSubmit = () => {
    if (gender) {
      setSlideType('dob')
    } else {
      setGenderErrorMessage('Please select one gender option.');
    }
  };

  const handleDateOfBirthSubmit = () => {
    setSlideType('email')
  };

  const handleEmailSubmit = () => {
    setSlideType('password')
  };

console.log('name', name);


  //FORMAT DOB
  //Parse the Date format
  const parseDate = (dateString) => {
    const dateParts = dateString.split('/'); // Split the date string into year, month, and day parts
    // const year = dateParts[0]; // Extract the year part
    const month = parseInt(dateParts[1], 10); // Extract the month part and convert it to a number
    const day = parseInt(dateParts[2], 10); // Extract the day part and convert it to a number
  
    // Array of suffixes for the day (1st, 2nd, 3rd, etc.)
    const suffixes = ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st'];
  
    // Get the suffix for the day
    const daySuffix = suffixes[day] || 'th';
  
    // Get the month name based on the month number
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthName = monthNames[month - 1];
  
    // Return the formatted date string
    return `${day}${daySuffix} ${monthName}`;
  };
  
  const formattedDOB = parseDate(selectedDob);
  console.log('dob', formattedDOB);

  console.log(password);
  

  const handleFinalSignupSubmit = async() => {
    try{

      const response = await signUp({
        data: {
          name,
          email,
          phone: phoneNumber,
          password
        }
      })

      console.log('signup response', response.data.message);
      if(response?.data?.message === 'User logged in successfully'){
        slModalClose();
      }
    }catch{

    }
  };
console.log(email)
console.log(password)
  const handleSignupSubmit = () => {
    // Handle signup submission
  };

  const SendOTP = () => {
    return (
      <Fragment>
      <div className='w-full p-8 flex flex-col items-center justify-center mt-40 max-md:mt-0'>
        
        
      <motion.div
          className="w-full h-12 flex items-center border px-4 gap-4 text-sm outline-none rounded-md bg-white"
          animate={{ y: phoneNumber?.length === 10 ? -10 : 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        >
          <span>+91</span>
          <input
            id="inputBorder"
            ref={phoneNumberInputRef}
            type="tel"
            placeholder="Enter your phone number"
            value={phoneNumber}
            maxLength={10}
            onChange={handlePhoneNumberChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            className="w-full outline-none border-l-2 border-gray-300 pl-4"
          />
        </motion.div>
          <p className='text-xs mt-2 text-gray-400'>OTP will send to this number</p>
      {phoneNumberError && <p className="error-message">{phoneNumberError}</p>}
      
        {isValidPhoneNumber && (
          <motion.button
          onClick={handleSendOTP}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ type: 'spring', stiffness: 150, damping: 20 }}
          className={`flex gap-2 items-center w-fit bg-yellow-600 text-white h-12 px-5 text-[0.85rem] rounded-full mt-6 ${
            isInputFocused ? 'focused' : ''
          }`}
        >
          Request OTP
          <ArrowForwardRoundedIcon />
        </motion.button>
        )
      }

      {/* <button className='text-center h-40 flex items-end '>
        <p className='hover:text-blue-500'>New to Utkarshita? <span className='text-pink-500 hover:text-blue-500'>Create an Account</span></p>
      </button> */}
        
    </div>
    </Fragment>
    );
  };

  const VerifyOTP = () => {
    // useEffect(() => {
    //   if (shouldProceedToSignup) {
    //     setShowVerifyOTPSlide(false);
    //     setShowNameSlide(true);
    //   }
    // }, [shouldProceedToSignup]);
    return (
      <div className="login_popup_otp_input_wrapper">
      <p className='otp_sent_text'>OTP Sent to the number </p>
      <span className='otp_sent_to_number'>{phoneNumber} <VerifiedRoundedIcon fontSize='extraSmall' className='phoneVerified'/></span>

      {verifyOTPLoading ? <Loader/> : <div className="otp_code_inputs">
      {otpCodes.map((code, index) => (
        <input
          key={index}
          type="text"
          value={code}
          onChange={(e) => handleOtpCodeChange(index, e.target.value)}
          onKeyDown={(e) => handleOtpKeyDown(index, e)}
          ref={(el) => otpInputRefs.current[index] = el}
          maxLength="1"
          className='mt-1 outline-pink-600'
        />
      ))}
      </div>}
      {/* <button onClick={handleVerifyOTP} disabled={otpCodes.some((code) => code === '')} className='verifyOTP_btn'>
        Verify OTP
      </button> */}
    </div>
    );
  };

  const NameSlide = () => {
    

    return (
      <div className="p-8 w-full h-full flex flex-col items-center justify-center">
      {/* <div className="backBtn_signUp_popup clsBtn_signUp_popup" onClick={slModalClose}>
        <KeyboardBackspaceRoundedIcon style={{ color: 'gray' }} />
      </div> */}
      <div className='w-full'>
     
        <div
          
          className="w-full mb-12"
        >
          <h6 className="text-[0.9rem] font-semibold text-gray-600">
            Let’s unlock something amazing together! <br/>Just a quick intro, and you are in.
          </h6>
          
        </div>
      
        <h4 className='text-[1rem] font-bold mb-4'>What's your Name?</h4>
        <input 
        type='text'
        autoFocus
        value={name}
        onChange={handleNameChange}
        className='w-full h-12 border-[1.5px] border-black rounded-md outline-none px-4 text-sm'
        />
        {!isNameValid && <p className='text-xs mt-2 text-gray-400'>Please enter a name with 5 to 20 characters.</p>}
        </div>
        <button onClick={handleNameSubmit} disabled={!isNameValid } className='mt-8 login_continue_button' >
            <ArrowForwardRoundedIcon fontSize="extraSmall" />
        </button>
      
    </div>
    );
  };


  console.log(gender);
  const firstName = name.split(" ")[0];
  const GenderSlide = () => {
    // Gender slide implementation
    return (
      <div className="slct_gndr_main">
      <div className="backBtn_signUp_popup clsBtn_signUp_popup" onClick={handleBackButton}>
        <ArrowBackRoundedIcon style={{ color: 'gray' }} />
      </div>
      <div className="slct_gndr_wrap">
        <div className='slct_gndr_inr'>
          <h4 className='popup_user_name'> Hi, {firstName}</h4>
          <h6>Gender?</h6>
          <div className="slct_gndr_spans">
            
            <span
            className={
              gender === 'Female'
                ? 'selected_gndr'
                : 'initial_slct_gndr'
            }
            onClick={() => handleGenderSelect('Female')}
            // disabled={isLoading || gender === 'Female'}
          >
            Female
          </span>
          <span
            className={
              gender === 'Male' ? 'selected_gndr' : 'initial_slct_gndr'
            }
            onClick={() => handleGenderSelect('Male')}
            disabled={isLoading || gender === 'Male'}
          >
            Male
          </span>
          <span
            className={
              gender === 'Non-binary'
                ? 'selected_gndr'
                : 'initial_slct_gndr'
            }
            onClick={() => handleGenderSelect('Non-binary')}
            disabled={isLoading || gender === 'Non-binary'}
          >
            Non-Binary
          </span>
        </div>
        </div>
        {/* <button onClick={handleGenderSubmit} disabled={!gender} className='login_continue_button'>
          Next <ArrowForwardRoundedIcon fontSize="extraSmall" />
        </button> */}
      </div>
    </div>

    );
  };

  console.log('SelectedDob', selectedDob)
  const DateOfBirthSlide = () => {
    // Date of Birth slide implementation
    return (
      <div className="dob_slide_wrapper relative">
      <div className="absolute top-[-20px] slide_back_button" onClick={handleBackButton}>
        <ArrowBackRoundedIcon style={{ color: 'gray' }} />
      </div>
      <div className='dob_wrap_inr'>
        <h4> {name}</h4>
        <h6>When is your Birthday?</h6>
        <div>
          <DatePicker handleDateSelection={handleDateSelection}/>
        </div>
        {!isNameValid && <p>Please enter a name with 5 to 20 characters.</p>}
      </div>
      <button onClick={handleDateOfBirthSubmit} disabled={!selectedDob} className='login_continue_button'>
        <ArrowForwardRoundedIcon fontSize='extraSmall'/>
      </button>
    </div>
    );
  };

  const EmailSlide = () => {
    useEffect(() => {
      if (isEmailInputFocused) {
        emailInputRef.current.focus();
      }
    }, [isEmailInputFocused]);

    useEffect(() => {
      if (isPasswordInputFocused) {
        passwordInputRef.current.focus();
      }
    }, [isPasswordInputFocused]);

    console.log(formattedDOB)
    // Email slide implementation
    return (
      <div className="p-8 relative w-full mt-4">
      <div className="absolute left-2 top-[0px] " onClick={handleBackButton}>
        <ArrowBackRoundedIcon style={{ color: 'black' }} />
      </div>
      <div className='email_pswrd_wrapper'>
      <div className='email_wrap_innr'>
        <div className='name_dob_wrap'>
        <div className='flex gap-1 mb-4'>
        <span className='font-semibold text-xl'>Hi,</span>
        <span className='font-semibold text-xl'>{name}</span>
        </div>
        {/* <h6 style={{display: 'flex', alignItems: 'center'}}><CakeRoundedIcon className='dob_icon dob_icon_add_margin' fontSize='small'/>{formattedDOB}</h6> */}
        </div>
        {/* <h4>Your Email?</h4> */}
        <input
          id='inputBorder'
          className='w-full'
          ref={emailInputRef}
          type="email"
          placeholder='Your Email?'
          value={email}
          onChange={handleEmailChange}
          onFocus={handleEmailInputFocus}
          onBlur={handleEmailInputBlur}
          autoComplete="off"
        />
        {emailError && <p className="error-message">{emailError}</p>}
      </div>
      <button onClick={handleEmailSubmit}  className='login_continue_button'>
        <ArrowForwardRoundedIcon fontSize='extraSmall'/>
      </button>
      </div>
    </div>
    );
  };


  const PasswordSlide = () => {
    // useEffect(() => {
    //   if (isEmailInputFocused) {
    //     emailInputRef.current.focus();
    //   }
    // }, [isEmailInputFocused]);

    useEffect(() => {
      if (isPasswordInputFocused) {
        passwordInputRef.current.focus();
      }
    }, [isPasswordInputFocused]);
    // Email slide implementation
    return (
      <div className="relative">
      <div className="absolute left-4 top-[-60px]" onClick={handleBackButton}>
        <ArrowBackRoundedIcon style={{ color: 'gray' }} />
      </div>
      <div className='email_pswrd_wrapper'>
      <div className='password_wrap_inr'>
        <div className='name_dob_wrap_pswrd_slide'>
          <h4>{name}<CheckCircleRoundedIcon fontSize='small' className='dob_icon dob_icon_add_margin'/></h4>
          {/* <h6 style={{display: 'flex', alignItems: 'center'}}><CakeRoundedIcon className='dob_icon dob_icon_add_margin' fontSize='small'/>{formattedDOB}</h6> */}
          <h6>{email}</h6>
        </div>
        <h4>Create Password</h4>
        <input
          ref={passwordInputRef}
          type="password"
          placeholder='Password'
          value={password}
          onChange={handlePasswordChange}
          onFocus={handlePasswordInputFocus}
          onBlur={handlePasswordInputBlur}
          autoComplete="off"
        />
        <div className='termsOfUse_wrap'>
            <span>By tapping on "Create Account", I agree to the <Link to=''>Terms of Use</Link> & <Link to=''>Privacy Policy</Link></span>    
        </div>
      </div>
      <button onClick={handleFinalSignupSubmit}  className='w-full'>
        Create Account
      </button>
      </div>
    </div>
    );
  };

  return (
    <Fragment>
      {/* {loading ? (
        <Loader className='loader_popup'/> // Show the loader while sliding to the name slide
      ) : ( */}
      <div className='w-full h-full flex max-sm:flex-col'>
        <div className='w-[45%] max-sm:w-full sm:rounded-l-2xl max-sm:rounded-t-2xl flex justify-center max-sm:py-12 bg-gradient-to-t from-pink-500 via-fuchsia-600 to-violet-700'
        // style={{
        //   background: 'linear-gradient(to top right, #50366f, #a6aab7, #bf368f, #bf347f, #fc72a5, #f9e2af)',
        // }}
        >
          
          <div className='w-52 mt-24 max-sm:mt-8 max-sm:w-full max-sm:text-center max-sm:px-12 max-sm:flex max-sm:flex-col max-sm:items-center'>
          <div className='mb-16 max-sm:mb-4'>
            <img src={logoUrl} alt='utkarshita' className='w-36 max-sm:w-40'/>
          </div>
            <p className='text-xl font-bold text-white'>Login</p>
            <p className='text-sm text-white'>Wrap Yourself in Authenticity. Login to Explore our Handloom Saree Haven!</p>
          </div>
        </div>
        <div className='flex-1 max-sm:bg-gradient-to-b from-pink-500 via-white to-white -mt-1'>
          {slideType === 'sendOtp' && <SendOTP />}
          {slideType === 'verifyOtp' && <VerifyOTP />}
          {slideType === 'name' && <NameSlide />}
          {slideType === 'dob' && <DateOfBirthSlide />}
          {slideType === 'gender' && <GenderSlide />}
          {slideType === 'email' && <EmailSlide />}
          {slideType === 'password' && <PasswordSlide/>}
        </div>
      </div>
      {/* )} */}
    </Fragment>
  );
};

export default SignInSignupComponent;